export default {
  path: ":alias/brands/form",
  component: resolve => require(["@/views/forms/list"], resolve),
  children: [
    {
      path: "list",
      component: resolve => require(["@/views/forms/list"], resolve)
    }
  ]
};
  